<template>
  <div class="toBe-processed">
    <div class="container">
      <div class="search-box">
        <!-- 事项描述 -->
        <div class="item">
          <span style="width: 70px">事项描述</span>
          <div class="item-content">
            <el-input
              v-model="toBeProcessedForm.todo_desc"
              size="small"
              clearable
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- 关联 -->
        <div class="item">
          <span style="width: 70px">关联</span>
          <div class="item-content">
            <el-input
              v-model="toBeProcessedForm.business_sn"
              size="small"
              clearable
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- 添加时间 -->
        <div class="item">
          <span style="width: 70px">添加时间</span>
          <div class="item-content">
            <el-date-picker
              v-model="toBeProcessedForm.add_time"
              size="small"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="getList"
            >
            </el-date-picker>
          </div>
          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1861') : false
            "
            @click="addItemBtn"
            >添加</el-button
          >
        </div>
      </div>

      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="toBeProcessedData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row[item.prop] | dateFormat }}
              </div>

              <div v-else-if="item.prop == 'todo_image'">
                <div
                  v-if="scope.row.todo_image.length"
                  class="flex between"
                  style="width: 300px"
                >
                  <el-image
                    :src="scope.row.todo_image[0]"
                    :preview-src-list="scope.row.todo_image"
                    style="width: 100px; height: 100px"
                  />
                </div>
              </div>

              <div v-else-if="item.prop == 'todo_desc'">
                <el-tooltip
                  effect="dark"
                  :content="scope.row[item.prop]"
                  placement="top-start"
                >
                  <div class="text-container">{{ scope.row[item.prop] }}</div>
                </el-tooltip>
              </div>

              <div v-else-if="item.prop == 'business_sn'">
                <span>{{ scope.row.type | typeText }}：</span>
                <el-link type="primary" @click="getTodoOrderRoute(scope.row)">{{
                  scope.row[item.prop]
                }}</el-link>
              </div>

              <div v-else-if="item.prop == 'remark'">
                <div class="text-container" style="line-clamp: 2">
                  {{ scope.row[item.prop] }}
                </div>
                <el-link
                  v-if="scope.row['log_list'].length"
                  type="primary"
                  @click="viewMoreBtn(scope.row)"
                  >查看更多</el-link
                >
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1862') : false
                "
                @click="handleBtn(scope.row)"
                >处理</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
    <!-- 添加事项 -->
    <el-dialog
      title="添加事项"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addItemDia"
      width="800px"
    >
      <el-form
        :model="addItemForm"
        :rules="rules"
        style="padding: 20px"
        label-width="100"
        ref="addItemRef"
      >
        <el-form-item
          label="事项描述"
          style="height: 300px; width: 100%; display: flex"
          prop="todo_desc"
          class="todo-desc"
        >
          <div style="padding-top: 10px">
            <el-input
              type="textarea"
              v-model="addItemForm.todo_desc"
              rows="13"
              maxlength="500"
              style="width: 600px"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item
          label="事项截图"
          label-width="100"
          style="height: 140px; width: 100%; display: flex"
        >
          <div
            style="
              padding-top: 10px;
              margin-left: 10px;
              display: flex;
              align-items: center;
            "
          >
            <UploadImg
              v-for="(item, index) in addItemForm.todo_image"
              :key="index"
              style="margin-right: 10px"
              :index="index"
              @emitImg="emitImg"
            >
            </UploadImg>
          </div>
        </el-form-item>

        <el-form-item label="关联" style="display: flex" label-width="100">
          <div style="margin-left: 40px">
            <el-radio-group v-model="addItemForm.type">
              <el-radio :label="1">处方</el-radio>
              <el-radio :label="2">诊疗订单</el-radio>
              <el-radio :label="3">商城订单</el-radio>
            </el-radio-group>
            <el-input
              v-model="addItemForm.business_sn"
              size="small"
              maxlength="50"
              clearable=""
              style="width: 400px; margin-left: 10px"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addItemDia = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="confirmAddItem('addItemRef')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看更多 -->
    <el-dialog title="更多处理结果" :visible.sync="handleResultDia">
      <div style="padding: 20px">
        <el-table :data="handleResultData" border>
          <el-table-column
            prop="admin_user_name"
            label="处理人"
            width="auto"
          ></el-table-column>
          <el-table-column prop="status" label="处理结果" width="auto">
            <template slot-scope="scope">
              {{ scope.row.status | statusText }}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="处理时间" width="auto">
            <template slot-scope="scope">
              {{ scope.row.create_time | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="auto"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 处理 -->
    <el-dialog
      title="处理"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="handleDia"
      width="460px"
    >
      <el-form :model="handleForm" label-width="100" style="padding: 20px">
        <el-form-item label="处理结果" style="display: flex">
          <el-radio-group v-model="handleForm.status">
            <el-radio :label="1">已解决</el-radio>
            <el-radio :label="2">未解决</el-radio>
            <el-radio :label="3">无需处理</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="备注"
          style="height: 120px; width: 100%; display: flex"
        >
          <div style="padding-top: 10px">
            <el-input
              type="textarea"
              v-model="handleForm.remark"
              rows="6"
              maxlength="100"
              style="width: 300px"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleDia = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmHandle"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import kefu from "@/api/kefu.js";
import common from "@/api/common.js";
import Pagination from "@/components/Pagination/index";
import UploadImg from "@/components/uploadImg/index";
export default {
  components: {
    Pagination,
    UploadImg,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      toBeProcessedForm: {
        status: 0,
        add_time: "",
        todo_desc: "",
        business_sn: "",
      },
      tableHeader: [
        {
          label: "添加时间",
          prop: "create_time",
          width: "160",
          align: "center",
          fixed: "left",
        },
        {
          label: "事项描述",
          prop: "todo_desc",
          width: "300",
          align: "center",
          fixed: false,
        },

        {
          label: "事项截图",
          prop: "todo_image",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "关联",
          prop: "business_sn",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "添加人",
          prop: "admin_user_name",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "处理记录",
          prop: "remark",
          width: "200",
          align: "center",
          fixed: false,
        },
      ],
      toBeProcessedData: [],
      addItemDia: false,
      addItemForm: {
        todo_desc: "",
        todo_image: [
          {
            pic: "",
            path: "",
          },
        ],
        type: 1,
        business_sn: "",
      },
      rules: {
        todo_desc: [{ required: true, message: "请输入", trigger: "change" }],
      },
      handleResultDia: false,
      handleResultData: [],
      handleDia: false,
      handleForm: {
        todo_id: "",
        status: 1,
        remark: "",
      },
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    dateFormatSS(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "已解决";
        case 2:
          return "未解决";
        case 3:
          return "无需处理";
      }
    },
    typeText(val) {
      switch (val) {
        case 1:
          return "处方";
        case 2:
          return "诊疗订单";
        case 3:
          return "商城订单";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.toBeProcessedForm.add_time = [start, end];
    },
    getList() {
      let params = Object.assign({}, this.pagination, this.toBeProcessedForm);
      params = _.omit(params, ["add_time"]);
      let times = this.toBeProcessedForm.add_time;
      params["add_start_time"] = times ? times[0] : "";
      params["add_end_time"] = times ? times[1] : "";
      this.tableLoading = true;
      kefu
        .getTodoList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.toBeProcessedData = data.list;
            this.totalNum = data.total;
          }
          this.tableLoading = false;
        })
        .catch((err) => (this.tableLoading = false));
    },
    // 跳转路由
    getTodoOrderRoute(row) {
      let { type, business_sn } = row;
      const loading = this.$loading();
      kefu
        .getTodoOrderRoute({ type, business_sn })
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.$router.push({
              path: data.url,
            });
          }
          loading.close();
        })
        .catch((err) => loading.close());
    },
    // 处理
    handleBtn(row) {
      let { todo_id, status, remark } = row;
      this.handleForm = {
        todo_id,
        status: 1,
        remark: "",
      };
      this.handleDia = true;
    },
    confirmHandle() {
      let params = Object.assign({}, this.handleForm);
      kefu.handleTodo(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("处理成功");
          this.handleDia = false;
          this.getList();
        }
      });
    },
    // 查看更多
    viewMoreBtn(row) {
      this.handleResultData = row.log_list;
      this.handleResultDia = true;
    },
    // 添加事项
    addItemBtn() {
      this.addItemForm = {
        todo_desc: "",

        type: 1,
        business_sn: "",
      };
      this.addItemForm.todo_image = [
        {
          pic: "",
          path: "",
        },
      ];
      this.addItemDia = true;
    },
    // 事项截图
    emitImg(data, index) {
      this.addItemForm.todo_image[index].pic = data.pic;
      this.addItemForm.todo_image[index].path = data.path;
      console.log(this.addItemForm);
      if (this.addItemForm.todo_image.length < 5) {
        this.addItemForm.todo_image.push({
          pic: "",
          path: "",
        });
      }
      this.$forceUpdate();
    },
    confirmAddItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = _.omit(this.addItemForm, ["todo_image"]);
          params.todo_image = this.addItemForm.todo_image
            .map((item) => {
              return item.pic;
            })
            .join(",");
          kefu
            .addTodo(params)
            .then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success("添加成功");
                this.addItemDia = false;
                this.getList();
              }
              loading.close();
            })
            .catch((err) => loading.close());
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.toBe-processed {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 90px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .text-container {
    overflow: hidden; /* 隐藏溢出文本 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 限制显示三行 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    line-height: 20px; /* 行高 */
  }
  .todo-desc {
    ::v-deep .el-form-item__content {
      height: auto;
    }
  }
}
</style>
